import PaymentMethodIndex from "@/views/directory/payment-method/PaymentMethodIndex.vue";

const paymentMethod = [
    {
        path: '/payment-methods',
        name: 'payment-method',
        component: PaymentMethodIndex,
        meta: {
            requiresAuth: true,
            roles: ['Super Admin', 'Admin Office'], 
        },
    }
]

export default paymentMethod;
